<template>
  <div>
    <div class="input-group mb-2 mr-sm-2">
      <div class="input-group-prepend">
        <div class="input-group-text">
          <span class="material-icons">
            today
          </span>
        </div>
      </div>
      <select class="form-control" @input="$emit('input', $event.target.value)">
        <slot></slot>
        <option v-for="(month, idx) in months" :value="idx" :key="idx">
          {{ month }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "MonthSelect",
  props: {
    value: {
      type: Number,
    },
  },
  data() {
    return {
      months: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  .input-group-prepend {
    border-right: none;
    .input-group-text {
      background-color: transparent;
    }
  }

  .form-control {
    appearance: none;
    border-left: none;
    &:focus {
      border-color: #ced4da;
      border-left-color: transparent;
    }
  }
}
</style>
